import React, { useState, useEffect } from "react";

const CustomModal = ({ fieldName, title, content, closeModal, saveField }) => {
    const [inputValue, setInputValue] = useState("");
    const [finalProducts, setFinalProducts] = useState(["", "", "", "", ""]);
    const [keyResults, setKeyResults] = useState(["", "", "", "", ""]);
    const [anchors, setAnchors] = useState(["", "", ""]);
    const [nextActions, setNextActions] = useState(["", "", ""]);
    const [shortTermGoals, setShortTermGoals] = useState(["", "", ""]);
    const [actionAnchors, setActionAnchors] = useState(["", "", ""]);
    const [repeatableBehaviors, setRepeatableBehaviors] = useState([["", "", ""], ["", "", ""], ["", "", ""]]);
    const [projectPulls, setProjectPulls] = useState([
        { shortTermGoal: "", dailySmartGoal: "", metric: "", schedule: "", minimumDose: "", weeklyCommitment: "" },
        { shortTermGoal: "", dailySmartGoal: "", metric: "", schedule: "", minimumDose: "", weeklyCommitment: "" },
        { shortTermGoal: "", dailySmartGoal: "", metric: "", schedule: "", minimumDose: "", weeklyCommitment: "" }
    ]);
    const [personalNonNegotiables, setPersonalNonNegotiables] = useState([
        { nonNegotiable: "", dailySmartGoal: "", metric: "", schedule: "", minimumDose: "", weeklyCommitment: "" },
        { nonNegotiable: "", dailySmartGoal: "", metric: "", schedule: "", minimumDose: "", weeklyCommitment: "" },
        { nonNegotiable: "", dailySmartGoal: "", metric: "", schedule: "", minimumDose: "", weeklyCommitment: "" },
        { nonNegotiable: "", dailySmartGoal: "", metric: "", schedule: "", minimumDose: "", weeklyCommitment: "" }
    ]);
    const [challengeSkillBalance, setChallengeSkillBalance] = useState({ activity: "", challenge: "", skill: "" });

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleFinalProductChange = (index, value) => {
        const newProducts = [...finalProducts];
        newProducts[index] = value;
        setFinalProducts(newProducts);
    };

    const handleKeyResultsChange = (index, value) => {
        const newResults = [...keyResults];
        newResults[index] = value;
        setKeyResults(newResults);
    };

    const handleAnchorChange = (index, value) => {
        const newAnchors = [...anchors];
        newAnchors[index] = value;
        setAnchors(newAnchors);
    };

    const handleNextActionsChange = (index, value) => {
        const newActions = [...nextActions];
        newActions[index] = value;
        setNextActions(newActions);
    };

    const handleShortTermGoalChange = (index, value) => {
        const newGoals = [...shortTermGoals];
        newGoals[index] = value;
        setShortTermGoals(newGoals);
    };

    const handleActionAnchorChange = (index, value) => {
        const newAnchors = [...actionAnchors];
        newAnchors[index] = value;
        setActionAnchors(newAnchors);
    };

    const handleRepeatableBehaviorChange = (anchorIndex, behaviorIndex, value) => {
        const newBehaviors = [...repeatableBehaviors];
        newBehaviors[anchorIndex] = [...newBehaviors[anchorIndex]];
        newBehaviors[anchorIndex][behaviorIndex] = value;
        setRepeatableBehaviors(newBehaviors);
    };

    const handleProjectPullChange = (index, field, value) => {
        const newPulls = [...projectPulls];
        newPulls[index] = { ...newPulls[index], [field]: value };
        setProjectPulls(newPulls);
    };

    const handlePersonalNonNegotiableChange = (index, field, value) => {
        const newNonNegotiables = [...personalNonNegotiables];
        newNonNegotiables[index] = { ...newNonNegotiables[index], [field]: value };
        setPersonalNonNegotiables(newNonNegotiables);
    };

    const handleChallengeSkillBalanceChange = (field, value) => {
        setChallengeSkillBalance(prev => ({ ...prev, [field]: value }));
    };

    useEffect(() => {
        setInputValue(content);
        if (fieldName === "globalView_2" && content) {
            try {
                const parsed = JSON.parse(content);
                if (parsed.finalProducts && parsed.keyResults) {
                    setFinalProducts(parsed.finalProducts);
                    setKeyResults(parsed.keyResults);
                }
            } catch (e) {
                // Keep empty arrays if content is not valid JSON
            }
        } else if (fieldName === "intentions_2" && content) {
            try {
                const parsed = JSON.parse(content);
                if (parsed.anchors && parsed.nextActions) {
                    setAnchors(parsed.anchors);
                    setNextActions(parsed.nextActions);
                }
            } catch (e) {
                // Keep empty arrays if content is not valid JSON
            }
        } else if (fieldName === "globalView_3" && content) {
            try {
                const parsed = JSON.parse(content);
                if (parsed.shortTermGoals) {
                    setShortTermGoals(parsed.shortTermGoals);
                }
            } catch (e) {
                // Keep empty arrays if content is not valid JSON
            }
        } else if (fieldName === "intentions_3" && content) {
            try {
                const parsed = JSON.parse(content);
                if (parsed.actionAnchors && parsed.repeatableBehaviors) {
                    setActionAnchors(parsed.actionAnchors);
                    setRepeatableBehaviors(parsed.repeatableBehaviors);
                }
            } catch (e) {
                // Keep empty arrays if content is not valid JSON
            }
        } else if (fieldName === "projectPulls_4" && content) {
            try {
                const parsed = JSON.parse(content);
                if (parsed.projectPulls) {
                    setProjectPulls(parsed.projectPulls);
                }
            } catch (e) {
                // Keep empty arrays if content is not valid JSON
            }
        } else if (fieldName === "personalNonNegotiables_4" && content) {
            try {
                const parsed = JSON.parse(content);
                if (parsed.personalNonNegotiables) {
                    setPersonalNonNegotiables(parsed.personalNonNegotiables);
                }
            } catch (e) {
                // Keep empty arrays if content is not valid JSON
            }
        } else if (fieldName === "challengeSkillBalance_3" && content) {
            try {
                const parsed = JSON.parse(content);
                if (parsed.activity !== undefined || parsed.challenge !== undefined || parsed.skill !== undefined) {
                    setChallengeSkillBalance(parsed);
                }
            } catch (e) {
                // Keep empty object if content is not valid JSON
            }
        }
    }, [content, fieldName]);

    const handleSave = () => {
        if (fieldName === "globalView_2") {
            const dataToSave = JSON.stringify({
                finalProducts,
                keyResults
            });
            saveField(dataToSave);
        } else if (fieldName === "intentions_2") {
            const dataToSave = JSON.stringify({
                anchors,
                nextActions
            });
            saveField(dataToSave);
        } else if (fieldName === "globalView_3") {
            const dataToSave = JSON.stringify({
                shortTermGoals
            });
            saveField(dataToSave);
        } else if (fieldName === "intentions_3") {
            const dataToSave = JSON.stringify({
                actionAnchors,
                repeatableBehaviors
            });
            saveField(dataToSave);
        } else if (fieldName === "projectPulls_4") {
            const dataToSave = JSON.stringify({
                projectPulls
            });
            saveField(dataToSave);
        } else if (fieldName === "personalNonNegotiables_4") {
            const dataToSave = JSON.stringify({
                personalNonNegotiables
            });
            saveField(dataToSave);
        } else if (fieldName === "challengeSkillBalance_3") {
            const dataToSave = JSON.stringify(challengeSkillBalance);
            saveField(dataToSave);
        } else {
            saveField(inputValue);
        }
    };

    return (
        <div className="modal fade show modal-overlay" style={{ display: "block" }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">{title}</h4>
                        <button className="btn-close" type="button" aria-label="Close" onClick={closeModal}></button>
                    </div>
                    <div className="modal-body">
                        {fieldName === "globalView_2" ? (
                            <div>
                                {[0, 1, 2, 3, 4].map((index) => (
                                    <div key={index} className="mb-4 p-3 border rounded">
                                        <h5 className="mb-3">Pair {index + 1}</h5>
                                        <div className="row">
                                            <div className="col-md-6 mb-2">
                                                <label className="font-weight-bold">Final Product {index + 1}</label>
                                                <textarea
                                                    className="form-control w-100"
                                                    style={{ resize: "none", minHeight: "3em" }}
                                                    value={finalProducts[index]}
                                                    onChange={(e) => handleFinalProductChange(index, e.target.value)}
                                                    rows={2}
                                                    placeholder="Enter final product..."
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="font-weight-bold">Key Results {index + 1}</label>
                                                <textarea
                                                    className="form-control w-100"
                                                    style={{ resize: "none", minHeight: "3em" }}
                                                    value={keyResults[index]}
                                                    onChange={(e) => handleKeyResultsChange(index, e.target.value)}
                                                    rows={2}
                                                    placeholder="Enter key results..."
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : fieldName === "intentions_2" ? (
                            <div>
                                {[0, 1, 2].map((index) => (
                                    <div key={index} className="mb-4 p-3 border rounded">
                                        <h5 className="mb-3">Pair {index + 1}</h5>
                                        <div className="row">
                                            <div className="col-md-6 mb-2">
                                                <label className="font-weight-bold">Anchor {index + 1}</label>
                                                <textarea
                                                    className="form-control w-100"
                                                    style={{ resize: "none", minHeight: "3em" }}
                                                    value={anchors[index]}
                                                    onChange={(e) => handleAnchorChange(index, e.target.value)}
                                                    rows={2}
                                                    placeholder="Enter anchor..."
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="font-weight-bold">Next actions {index + 1}</label>
                                                <textarea
                                                    className="form-control w-100"
                                                    style={{ resize: "none", minHeight: "3em" }}
                                                    value={nextActions[index]}
                                                    onChange={(e) => handleNextActionsChange(index, e.target.value)}
                                                    rows={2}
                                                    placeholder="Enter next actions..."
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : fieldName === "globalView_3" ? (
                            <div>
                                {[0, 1, 2].map((index) => (
                                    <div key={index} className="mb-3">
                                        <label className="font-weight-bold">Short term goal {index + 1}</label>
                                        <textarea
                                            className="form-control w-100"
                                            style={{ resize: "none", minHeight: "3em" }}
                                            value={shortTermGoals[index]}
                                            onChange={(e) => handleShortTermGoalChange(index, e.target.value)}
                                            rows={2}
                                            placeholder="Enter short term goal..."
                                        />
                                    </div>
                                ))}
                            </div>
                        ) : fieldName === "intentions_3" ? (
                            <div>
                                {[0, 1, 2].map((anchorIndex) => (
                                    <div key={anchorIndex} className="mb-4 p-3 border rounded">
                                        <h5 className="mb-3">ACTION ANCHOR {anchorIndex + 1}</h5>
                                        <div className="mb-3">
                                            <label className="font-weight-bold">Action Anchor Title</label>
                                            <textarea
                                                className="form-control w-100"
                                                style={{ resize: "none", minHeight: "2em" }}
                                                value={actionAnchors[anchorIndex]}
                                                onChange={(e) => handleActionAnchorChange(anchorIndex, e.target.value)}
                                                rows={1}
                                                placeholder="e.g., PROGRAM CREATION (WEEKLY)"
                                            />
                                        </div>
                                        <div>
                                            <label className="font-weight-bold">Repeatable Behaviors</label>
                                            {[0, 1, 2].map((behaviorIndex) => (
                                                <div key={behaviorIndex} className="mb-2">
                                                    <textarea
                                                        className="form-control w-100"
                                                        style={{ resize: "none", minHeight: "2em" }}
                                                        value={repeatableBehaviors[anchorIndex][behaviorIndex]}
                                                        onChange={(e) => handleRepeatableBehaviorChange(anchorIndex, behaviorIndex, e.target.value)}
                                                        rows={1}
                                                        placeholder={`${behaviorIndex + 1}.`}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : fieldName === "projectPulls_4" ? (
                            <div>
                                {[0, 1, 2].map((index) => (
                                    <div key={index} className="mb-4 p-3 border rounded">
                                        <h5 className="mb-3">PROJECT PULL {index + 1}</h5>
                                        <div className="mb-2">
                                            <label className="font-weight-bold">1. Short-term goal → what you will do (specific action)</label>
                                            <textarea
                                                className="form-control w-100"
                                                style={{ resize: "none", minHeight: "2em" }}
                                                value={projectPulls[index].shortTermGoal}
                                                onChange={(e) => handleProjectPullChange(index, "shortTermGoal", e.target.value)}
                                                rows={1}
                                                placeholder="Enter short-term goal..."
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <label className="font-weight-bold">2. Daily SMART goal → what you will do (specific action)</label>
                                            <textarea
                                                className="form-control w-100"
                                                style={{ resize: "none", minHeight: "2em" }}
                                                value={projectPulls[index].dailySmartGoal}
                                                onChange={(e) => handleProjectPullChange(index, "dailySmartGoal", e.target.value)}
                                                rows={1}
                                                placeholder="Enter daily SMART goal..."
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <label className="font-weight-bold">3. Metric → minutes OR reps OR units of output (choose ONE primary metric)</label>
                                            <textarea
                                                className="form-control w-100"
                                                style={{ resize: "none", minHeight: "2em" }}
                                                value={projectPulls[index].metric}
                                                onChange={(e) => handleProjectPullChange(index, "metric", e.target.value)}
                                                rows={1}
                                                placeholder="Enter metric..."
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <label className="font-weight-bold">4. Schedule → day(s) + time window / timebox</label>
                                            <textarea
                                                className="form-control w-100"
                                                style={{ resize: "none", minHeight: "2em" }}
                                                value={projectPulls[index].schedule}
                                                onChange={(e) => handleProjectPullChange(index, "schedule", e.target.value)}
                                                rows={1}
                                                placeholder="Enter schedule..."
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <label className="font-weight-bold">5. Minimum dose (fallback) → what you do when life gets chaotic</label>
                                            <textarea
                                                className="form-control w-100"
                                                style={{ resize: "none", minHeight: "2em" }}
                                                value={projectPulls[index].minimumDose}
                                                onChange={(e) => handleProjectPullChange(index, "minimumDose", e.target.value)}
                                                rows={1}
                                                placeholder="Enter minimum dose..."
                                            />
                                        </div>
                                        <div>
                                            <label className="font-weight-bold">6. Weekly commitment / checkpoint → what "done this week" means</label>
                                            <textarea
                                                className="form-control w-100"
                                                style={{ resize: "none", minHeight: "2em" }}
                                                value={projectPulls[index].weeklyCommitment}
                                                onChange={(e) => handleProjectPullChange(index, "weeklyCommitment", e.target.value)}
                                                rows={1}
                                                placeholder="Enter weekly commitment..."
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : fieldName === "personalNonNegotiables_4" ? (
                            <div>
                                {[0, 1, 2, 3].map((index) => (
                                    <div key={index} className="mb-4 p-3 border rounded">
                                        <h5 className="mb-3">PERSONAL NON-NEGOTIABLE {index + 1}</h5>
                                        <div className="mb-2">
                                            <label className="font-weight-bold">1. Non-negotiable → what you will do (specific action)</label>
                                            <textarea
                                                className="form-control w-100"
                                                style={{ resize: "none", minHeight: "2em" }}
                                                value={personalNonNegotiables[index].nonNegotiable}
                                                onChange={(e) => handlePersonalNonNegotiableChange(index, "nonNegotiable", e.target.value)}
                                                rows={1}
                                                placeholder="Enter non-negotiable..."
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <label className="font-weight-bold">2. Daily SMART goal → what you will do (specific action)</label>
                                            <textarea
                                                className="form-control w-100"
                                                style={{ resize: "none", minHeight: "2em" }}
                                                value={personalNonNegotiables[index].dailySmartGoal}
                                                onChange={(e) => handlePersonalNonNegotiableChange(index, "dailySmartGoal", e.target.value)}
                                                rows={1}
                                                placeholder="Enter daily SMART goal..."
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <label className="font-weight-bold">3. Metric → minutes OR reps OR units of output (choose ONE primary metric)</label>
                                            <textarea
                                                className="form-control w-100"
                                                style={{ resize: "none", minHeight: "2em" }}
                                                value={personalNonNegotiables[index].metric}
                                                onChange={(e) => handlePersonalNonNegotiableChange(index, "metric", e.target.value)}
                                                rows={1}
                                                placeholder="Enter metric..."
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <label className="font-weight-bold">4. Schedule → day(s) + time window / timebox</label>
                                            <textarea
                                                className="form-control w-100"
                                                style={{ resize: "none", minHeight: "2em" }}
                                                value={personalNonNegotiables[index].schedule}
                                                onChange={(e) => handlePersonalNonNegotiableChange(index, "schedule", e.target.value)}
                                                rows={1}
                                                placeholder="Enter schedule..."
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <label className="font-weight-bold">5. Minimum dose (fallback) → what you do when life gets chaotic</label>
                                            <textarea
                                                className="form-control w-100"
                                                style={{ resize: "none", minHeight: "2em" }}
                                                value={personalNonNegotiables[index].minimumDose}
                                                onChange={(e) => handlePersonalNonNegotiableChange(index, "minimumDose", e.target.value)}
                                                rows={1}
                                                placeholder="Enter minimum dose..."
                                            />
                                        </div>
                                        <div>
                                            <label className="font-weight-bold">6. Weekly commitment / checkpoint → what "done this week" means</label>
                                            <textarea
                                                className="form-control w-100"
                                                style={{ resize: "none", minHeight: "2em" }}
                                                value={personalNonNegotiables[index].weeklyCommitment}
                                                onChange={(e) => handlePersonalNonNegotiableChange(index, "weeklyCommitment", e.target.value)}
                                                rows={1}
                                                placeholder="Enter weekly commitment..."
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : fieldName === "challengeSkillBalance_3" ? (
                            <div>
                                <div className="mb-3">
                                    <label className="font-weight-bold">Activity</label>
                                    <textarea
                                        className="form-control w-100"
                                        style={{ resize: "none", minHeight: "2em" }}
                                        value={challengeSkillBalance.activity}
                                        onChange={(e) => handleChallengeSkillBalanceChange("activity", e.target.value)}
                                        rows={1}
                                        placeholder="Enter activity..."
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="font-weight-bold">Challenge</label>
                                    <textarea
                                        className="form-control w-100"
                                        style={{ resize: "none", minHeight: "2em" }}
                                        value={challengeSkillBalance.challenge}
                                        onChange={(e) => handleChallengeSkillBalanceChange("challenge", e.target.value)}
                                        rows={1}
                                        placeholder="Enter challenge..."
                                    />
                                </div>
                                <div>
                                    <label className="font-weight-bold">Skill</label>
                                    <textarea
                                        className="form-control w-100"
                                        style={{ resize: "none", minHeight: "2em" }}
                                        value={challengeSkillBalance.skill}
                                        onChange={(e) => handleChallengeSkillBalanceChange("skill", e.target.value)}
                                        rows={1}
                                        placeholder="Enter skill..."
                                    />
                                </div>
                            </div>
                        ) : (
                            <textarea
                                className="form-control w-100"
                                style={{ resize: "none", minHeight: "10em" }}
                                value={inputValue}
                                onChange={handleInputChange}
                                rows={Math.max(3, inputValue?.split("\n").length)}
                                placeholder={fieldName === "globalView_1" && content === "" ? "I want to" :
                                    fieldName === "intentions_1" && content === "" ? "I will" :
                                    fieldName === "globalView_2" && content === "" ? "For the next 3 to 5 years I want to engage in/deliver" :
                                    fieldName === "intentions_2" && content === "" ? "I will" :
                                    fieldName === "globalView_3" && content === "" ? "This year, I want to" :
                                    fieldName === "intentions_3" && content === "" ? "I intend to" :
                                    fieldName === "processGoals_4" && content === "" ? "I intend to" :
                                    ''
                                }
                            ></textarea>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-light" type="button" onClick={closeModal}>Close</button>
                        <button className="btn btn-primary" type="button" onClick={handleSave}>Save</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomModal;
